import { render } from "./aside.vue?vue&type=template&id=6ccd971e&scoped=true"
import script from "./aside.vue?vue&type=script&lang=js"
export * from "./aside.vue?vue&type=script&lang=js"

import "./aside.vue?vue&type=style&index=0&id=6ccd971e&lang=scss&scoped=true"

import exportComponent from "/usr/local/apps/meng/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ccd971e"]])

export default __exports__